<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>
    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          md="10"
          class="px-1"
          order="2"
          order-md="1"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_search"
              v-model="tableQRPh.filter.search"
              type="text"
              size="sm"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
              :readonly="tableQRPh.busy || exporter.busy"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Paid At"
            label-for="filter_paid_at"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_paid_at"
              v-model="tableQRPh.filter.date"
              size="sm"
              type="date"
              :disabled="tableQRPh.busy || exporter.busy"
              required
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1 mb-2"
          order="3"
        >
          <b-button
            size="sm"
            type="button"
            variant="primary"
            class="mr-1"
            :disabled="tableQRPh.busy || exporter.busy"
            @click="tableQRPHRerfresh"
          >
            <b-icon
              icon="arrow-clockwise"
              :animation="(tableQRPh.busy ? 'spin' : null)"
            /> {{ tableQRPh.busy ? 'Loading' : 'Reload' }}
          </b-button>
          <b-overlay
            v-if="tableQRPh.filter.date"
            rounded
            opacity="0.1"
            spinner-small
            class="d-inline"
            spinner-variant="warning"
            :show="exporter.busy"
          >
            <json-excel
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              :class="(tableQRPh.busy || exporter.busy ? `btn btn-success btn-sm disabled` : `btn btn-success btn-sm`)"
              :fetch="excelQRPhProvider"
              :before-generate="onStartExcelExport"
              :before-finish="onFinishExcelExport"
              :fields="exporter.excel.fields"
              :escape-csv="exporter.excel.escape"
              :type="exporter.excel.type"
              :header="exporter.excel.header"
              :footer="exporter.excel.footer"
              :name="excelFileName"
              :stringify-long-num="exporter.excel.stringifyLongNum"
              :meta="exporter.excel.meta"
              worksheet="QRPH"
            >
              {{ exporter.busy ? 'Exporting' : 'Export As Excel' }}
            </json-excel>
          </b-overlay>

        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableQRPh"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableQRPh.perPage"
            :current-page="tableQRPh.currentPage"
            :items="tableQRPhProvider"
            :fields="tableQRPh.fields"
            :sort-by.sync="tableQRPh.sortBy"
            :sort-desc.sync="tableQRPh.sortDesc"
            :sort-direction="tableQRPh.sortDirection"
            :filter="tableQRPh.filter"
            :filter-included-fields="tableQRPh.filterOn"
            :busy="tableQRPh.busy"
          >
            <template #cell(index)="row">
              {{ tableQRPh.currentPage * tableQRPh.perPage - tableQRPh.perPage + (row.index + 1) }}
            </template>

            <template #cell()="row">
              <div class="text-wrap text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell(amount)="row">
              <div
                class="text-md-nowrap text-right"
                style="min-width: 100px !important;"
              >
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  v-if="row.item.user_payload"
                  size="sm"
                  :variant="row.detailsShowing ? 'danger' : 'primary' "
                  @click="row.toggleDetails"
                >
                  {{ row.detailsShowing ? 'Hide' : 'User' }} Payload
                </b-button>
              </div>
            </template>

            <template #row-details="{ item }">
              <b-form-group
                label="Payload"
                label-class="font-weight-bolder"
                class="mb-2 px-5"
              >
                <vue-json-pretty
                  :data="item.user_payload"
                />
              </b-form-group>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableQRPh.perPage"
            :options="tableQRPh.pageOptions"
            size="sm"
            class="w-100 w-md-25"
            :disabled="tableQRPh.busy"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableQRPh.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableQRPh.totalRows"
            :per-page="tableQRPh.perPage"
            :disabled="tableQRPh.busy"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
// import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SMerchantReport, SMerchantExport } from '@/services'
import formatter from '@/mixins/formatter'
import Ripple from 'vue-ripple-directive'
import misc from '@/mixins/misc'
import createDate from 'moment'

export default {
  name: 'MerchantReportsQRPH',

  middleware: ['auth', 'merchant'],

  directives: {
    Ripple
  },

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'QRPH'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      tableQRPh: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null,
          date: createDate().format('YYYY-MM-DD')
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 7, key: 'action', class: 'text-center min-w-150px' },
          { mobile: 1, key: 'created_at', class: 'min-w-200px', formatter: this.dateTimeFormatter },
          { mobile: 2, key: 'partner_reference', class: 'min-w-350px' },
          { mobile: 3, key: 'provider_reference', class: 'min-w-350px' },
          { mobile: 4, key: 'amount', class: 'min-w-150px', formatter: this.numberFormatter },
          { mobile: 5, key: 'status', class: 'text-center min-w-100px' },
          { mobile: 6, key: 'paid_at', class: 'min-w-200px', formatter: this.dateTimeFormatter }
        ].sort(this.scaleOnMobile)
      },
      exporter: {
        busy: false,
        pdf: null,
        excel: {
          header: [],
          escape: false,
          stringifyLongNum: true,
          type: 'xls',
          meta: [],
          fields: {
            '#': {
              field: 'page_number'
            },
            'Created At': {
              field: 'created_at',
              callback: createdAt => `="${this.dateTimeFormatter(createdAt)}"`
            },
            'Partner Reference': {
              field: 'partner_reference'
            },
            'Provider Reference': {
              field: 'provider_reference'
            },
            Amount: {
              field: 'amount',
              callback: amount => this.numberFormatter(amount) || 0.00
            },
            Status: {
              field: 'status'
            },
            'Paid At': {
              field: 'paid_at',
              callback: paidAt => `="${this.dateTimeFormatter(paidAt)}"`
            }
          },
          footer: []
        }
      }
    }
  },

  computed: {
    excelFileName () {
      return `QRPH-${this.dateFormatter(this.tableQRPh.filter.date)}`
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async tableQRPhProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableQRPh.busy = true
      return await SMerchantReport.getQRPh(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search,
          filter_paid_at: filter.date
        })
      ).then(({ data }) => {
        this.tableQRPh.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableQRPh.busy = false
      })
    },

    tableQRPHRerfresh () {
      this.$refs.tableQRPh.refresh()
    },

    async excelQRPhProvider () {
      if (this.exporter.busy || this.tableQRPh.busy) {
        return null
      }
      this.exporter.busy = true
      return await SMerchantExport.getQRPh(
        this.objectToUrl({
          filter_text: this.tableQRPh.filter.search,
          filter_paid_at: this.tableQRPh.filter.date
        })
      ).then(({ data }) => {
        if (data.items.length <= 0) {
          this.swalInvalid(
            'No available data to be Exported. Try changing the date range.',
            'Notice'
          )
        }
        return data.items.map((item, i) => {
          item.page_number = Number(i) + 1
          return item
        })
      }).catch(() => []).finally(() => {
        this.exporter.busy = false
      })
    },

    onStartExcelExport () {
      if (this.exporter.busy || this.tableQRPh.busy) {
        return null
      }

      this.exporter.excel.header = [
        'QRPH',
        `As of ${this.dateShortFormatter(this.tableQRPh.filter.date)}`,
        '&nbsp;'
      ]
    },

    onFinishExcelExport () {
    }
  }
}
</script>
